export default [
  {
    slug: 'ladenwithterror',
    category: 'interactive',
    title: 'Laden With Terror',
    description: {
      __html:
        "This is an interactive piece (click <a href='https://meinstein.github.io/laden-with-terror/'>here</a> to view) that examines every New York Times article in the 10 years between 9/11 and Osama bin Laden’s death that mentions the now-deceased terrorist by name. The articles are organized in categories based on the month written and the sections they appear in."
    },
    thumbnail: '/sm/ladenwithterror.gif',
    images: [
      {
        md: '/md/laden_with_terror.png',
        lg: 'https://meinstein.github.io/laden-with-terror/'
      }
    ]
  },
  {
    slug: 'kbviz',
    category: 'interactive',
    title: 'KB Viz',
    thumbnail: '/sm/kb_viz.png',
    description: {
      __html:
        "This interactive visualization (click <a href='https://meinstein.github.io/kobe/'>here</a> to view) examines and compares key statistics from every single game during Kobe Bryant's illustrious career in the NBA."
    },
    images: [
      {
        md: '/md/kbviz.png',
        lg: 'https://meinstein.github.io/kobe/'
      }
    ]
  },
  {
    slug: 'neistat',
    category: 'interactive',
    title: 'Nei-Stat',
    thumbnail: '/sm/neistat.gif',
    description: {
      __html:
        "Casey Neistat has been creating a daily vlog since April 2015. His following has been growing steadily and this dashboard keeps track of many key metrics for every vlog. Click <a href='https://meinstein.github.io/nei-stat/'>here</a> to view live dashboard. To view a similiar dashboard of Kobe Bryant's entire NBA career, click <a href='https://meinstein.github.io/kobe/'>here</a>."
    },
    images: [
      {
        md: '/md/neistat.gif',
        lg: 'https://meinstein.github.io/nei-stat/'
      }
    ]
  },
  {
    slug: 'touchdowns',
    category: 'infographic',
    title: 'Touchdowns',
    thumbnail: '/sm/touchdowns.jpg',
    description: {
      __html:
        'On 10/19/2014, Peyton Manning surpassed Brett Favre to become the NFL’s all-time leader in passing touchdowns. These two visualizations take a sequential look at every pass thrown by both quarterbacks over the course of their careers. In addition, any player who has received five or more touchdown passes is listed on the far right.'
    },
    images: [
      {
        md: '/md/touchdowns_favre.jpg',
        lg: '/lg/touchdowns_favre.jpg'
      },
      {
        md: '/md/touchdowns_manning.jpg',
        lg: '/lg/touchdowns_manning.jpg'
      }
    ]
  },
  {
    slug: 'terror',
    category: 'infographic',
    title: 'Terror',
    thumbnail: '/sm/terror.jpg',
    description: {
      __html:
        'This visualization examines every New York Times article in the 10 years between 9/11 and Osama bin Laden’s death that mentions the now-deceased terrorist by name. It was created by randomly arranging the headlines in the shape a void - reflecting the inherent darkness of this decade in American history.'
    },
    images: [
      {
        md: '/md/terror.jpg',
        lg: '/lg/terror.jpg'
      }
    ]
  },
  {
    slug: 'truecar',
    category: 'infographic',
    title: 'TrueCar',
    thumbnail: '/sm/truecar.jpg',
    description: {
      __html:
        "As an information designer on TrueCar's marketing team, I was tasked with displaying the company's data in clear and novel ways."
    },
    images: [
      {
        md: '/md/gdp_graph.png',
        lg: '/lg/gdp_graph.png'
      },
      {
        md: '/md/bars.jpg',
        lg: '/lg/bars.jpg'
      },
      {
        md: '/md/bezier.jpg',
        lg: '/lg/bezier.jpg'
      },
      {
        md: '/md/radial.jpg',
        lg: '/lg/radial.jpg'
      }
    ]
  },
  {
    slug: 'guns',
    category: 'animation',
    title: 'Killer Amendment',
    thumbnail: '/sm/guns.jpg',
    description: {
      __html:
        "In 2013, there were over 11,000 gun-related homicides in the United States. That means that each letter of the second amendment represents approximately 98 deaths. Click <a href='http://www.cdc.gov/nchs/fastats/homicide.htm'>here</a> to view data."
    },
    images: [
      {
        md: '/md/guns.jpg',
        lg: '/lg/guns.jpg'
      }
    ],
    videos: [
      {
        iframeSrc: 'https://www.youtube.com/embed/Jnx61j7KCIU'
      }
    ]
  },
  {
    slug: 'porn',
    category: 'infographic',
    title: 'Most-Viewed Porn',
    thumbnail: '/sm/porn.jpg',
    description: {
      __html:
        'An examination of the 24 most-viewed videos across 15 categories on the most popular pornography platform in the United States.'
    },
    images: [
      {
        md: '/md/porn.jpg',
        lg: '/lg/porn.jpg'
      }
    ]
  },
  {
    slug: 'als',
    category: 'animation',
    title: 'ALS',
    thumbnail: '/sm/als.jpg',
    description: {
      __html:
        'This visualization uses data from Google Trends to show the global spread of the Ice Bucket Challenge over a 30 day period (August 6th – September 7th, 2014). The bottom numbers and charts track the daily volume of three primary hashtags associated with the challenge, as well as the top tweet associated with that hashtag for any particular day.'
    },
    videos: [
      {
        iframeSrc: 'https://www.youtube.com/embed/qTEchen97rQ'
      }
    ]
  },
  {
    slug: 'cube',
    category: 'interactive',
    title: '3D Data Viz',
    thumbnail: '/sm/data_cube.gif',
    description: {
      __html:
        "I have enjoyed experimenting with WebGL/THREE.js to create prototypes for data visualizations in 3D space. For the bezier grid, click <a href='http://meinstein.github.io/bezier_chart'>here</a>. For the data cube, click <a href='http://meinstein.github.io/data_cube'>here</a>."
    },
    images: [
      {
        md: '/md/bezier_chart.gif',
        lg: 'http://meinstein.github.io/bezier_chart'
      },
      {
        md: '/md/data_cube.gif',
        lg: 'http://meinstein.github.io/data_cube'
      }
    ]
  },
  {
    slug: 'networks',
    category: 'animation',
    title: 'Networks',
    thumbnail: '/sm/networks.jpg',
    description: {
      __html: 'A series of dynamic visualizations that explore social networks (stay tuned for more!).'
    },
    videos: [
      {
        iframeSrc: 'https://www.youtube.com/embed/uurifRpJw-8'
      }
    ]
  },
  {
    slug: 'stars',
    category: 'infographic',
    title: 'Top Porn Stars',
    thumbnail: '/sm/stars.jpg',
    description: {
      __html:
        'This visualization explores what the top 100 porn stars (based on the preferences of American viewers) look like. This list was put together using XVIDEOS.com, which is the most visited porn website in both the United States and the world. The individual data about each porn star was gathered using IAFD.com.'
    },
    images: [
      {
        md: '/md/stars.jpg',
        lg: '/lg/stars.jpg'
      }
    ]
  },
  {
    slug: 'beer',
    category: 'infographic',
    title: 'Top Beers',
    thumbnail: '/sm/beer.jpg',
    description: {
      __html:
        'This is a visualization of the Top 100 Beers according to BeerAdvocate.com. The order of beers is based on a formula that can be found at the bottom of this page. All data was collected on 4/8/2015.'
    },
    images: [
      {
        md: '/md/beer.jpg',
        lg: '/md/beer.jpg'
      }
    ]
  },
  {
    slug: 'text_bubbles',
    category: 'infographic',
    title: 'Text Bubbles',
    thumbnail: '/sm/text_bubbles.jpg',
    description: {
      __html:
        'The complexity of a piece of writing is often reflected in the number of ‘big words’ an author chooses to employ. In this image, two bodies of text have been converted – word by word – into two corresponding collections of bubbles. The size of each bubble reflects the number of characters in each word from the original text.'
    },
    images: [
      {
        md: '/md/text_bubbles.jpg',
        lg: '/md/text_bubbles.jpg'
      }
    ]
  },
  {
    slug: 'tags',
    category: 'infographic',
    title: 'Porn Tags',
    thumbnail: '/sm/tags.jpg',
    description: {
      __html:
        'This visualization examines the most-used tags on XVideos, which is also the most popular pornographic video sharing website in the world. Tags are used in order to categorize and generally organize transferred content.'
    },
    images: [
      {
        md: '/md/tags.jpg',
        lg: '/lg/tags.jpg'
      }
    ]
  },
  {
    slug: 'tours',
    category: 'animation',
    title: 'Concert Tours',
    thumbnail: '/sm/tours.jpg',
    description: {
      __html:
        'This visualization maps the movements of the five highest-grossing concert tours of all time. The ranking is based on actual gross revenue (not adjusted for inflation). When adjusted for inflation, AC/DC’s “Black Ice World Tour” surpasses Roger Waters’ “The Wall Live.” The length of each section in the video is relative to the actual duration of the tour.'
    },
    videos: [
      {
        iframeSrc: 'https://www.youtube.com/embed/4m3yd7M5Vxg'
      }
    ]
  },
  {
    slug: 'penal-code',
    category: 'infographic',
    title: 'Penal Code',
    thumbnail: '/sm/penal-code.jpg',
    description: {
      __html:
        'Title 18 of the United States Code is the criminal and penal code of the federal government of the United States. This visualization is an exhaustive overview of Title 18.'
    },
    images: [
      {
        md: '/md/penal-code.jpg',
        lg: '/lg/penal-code.jpg'
      }
    ]
  },
  {
    slug: 'href',
    category: 'infographic',
    title: 'Wikipedia',
    thumbnail: '/sm/href.jpg',
    description: {
      __html:
        'This visualization goes through a list of the top 1000 U.S. cities (ordered by population) and their corresponding Wikipedia pages in search of all “href” attributes. Created: June, 2014.'
    },
    images: [
      {
        md: '/md/href.jpg',
        lg: '/lg/href.jpg'
      }
    ]
  },
  {
    slug: 'highways',
    category: 'infographic',
    title: 'Highways',
    thumbnail: '/sm/highways.jpg',
    description: {
      __html:
        'The first visualization measures the length of individual highways that make up the interstate highway system within the 48 contiguous states. The second visualization imagines a highway Pangaea (without altering the relative orientation of each highway). The third visualization places the 46 highway interchanges in Los Angeles County in order of magnitude. (Note: Interchanges with SR-138 are not included.)'
    },
    images: [
      {
        md: '/md/highways.jpg',
        lg: '/lg/highways.jpg'
      },
      {
        md: '/md/highways_2.jpg',
        lg: '/md/highways_2.jpg'
      },
      {
        md: '/md/interchanges.jpg',
        lg: '/lg/interchanges.jpg'
      }
    ]
  },
  {
    slug: 'philosophy',
    category: 'interactive',
    title: 'Philosophy',
    thumbnail: '/sm/manuscript.gif',
    description: {
      __html:
        "This piece attempts to visualize a body of philosophy by examining its individual parts without disrupting its contingent nature. Click <a href='http://meinstein.github.io/manuscript'>here</a> to view live version."
    },
    images: [
      {
        md: '/md/philosophy.gif',
        lg: 'http://meinstein.github.io/manuscript'
      }
    ]
  },
  {
    slug: 'hova',
    category: 'infographic',
    title: 'Hova',
    thumbnail: '/sm/hova.jpg',
    description: {
      __html:
        "This image contains 21 years (1988-2009) worth of Jay-Z’s music. Each song is converted into a ‘pseudo-wavelength’ based on the overall number of words, as well as the number of characters contained by each word. Click <a href='http://www.staplecrops.com/rap-data-pack-1-jay-z-released/'>here</a> to view data."
    },
    images: [
      {
        md: '/md/hova.jpg',
        lg: '/lg/hova.jpg'
      }
    ]
  },
  {
    slug: 'roundabout',
    category: 'animation',
    title: 'Roundabout',
    thumbnail: '/sm/roundabout.jpg',
    description: {
      __html:
        'The first video is a portrait of 15 roly poly crawling around in a circular dish. The second video is from Martin Scorsese’s Goodfellas, which contains an epic 3-minute ‘long-take’ of Henry Hill and his girlfriend as they wind their way from the street into a restaurant. This tracks the motion of the scene as it unfolds, leaving behind a visible trail that loosely parallels changes in elevation and direction.'
    },
    videos: [
      {
        iframeSrc: 'https://www.youtube.com/embed/_Yt-AuseT7g'
      },
      {
        iframeSrc: 'https://www.youtube.com/embed/wDRfrux84OY'
      }
    ]
  }
]
